<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Products and Services</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <b>Products and Services</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12">
        <router-link
          to="/products-services/add"
          type="button"
          class="btn btn-primary mb-2 pull-right"
        >Add</router-link>
      </div>

      <div class="col-12 col-lg-5 col-sm-12 d-flex flex-column flex-sm-row align-items-center">
        <span class="m-auto"></span>
        <div class="btn-group col-lg-6 col-sm-12 pl-0 pl-sm-3" role="group">
          <button
            class="btn btn-secondary active"
            id="btn-active"
            type="button"
            @click="active()"
          >Active</button>
          <button
            class="btn btn-secondary"
            id="btn-inactive"
            type="button"
            @click="inactive()"
          >Inactive</button>
          <button
            class="btn btn-secondary"
            id="btn-pending"
            type="button"
            @click="pending()"
          >Pending</button>
          <button
            class="btn btn-secondary"
            id="btn-resubmit"
            type="button"
            @click="resubmit()"
          >Resubmit</button>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <p>Add new products and services detail to be shown on Takaful Brunei Mobile App</p>

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active" class>
              <h4 class="card-title mb-3">
                <b>Active</b>
              </h4>
              <!-- <p>The table shows the list of current active products and services that has been approved by Takaful Brunei and shown to public via Takaful Brunei Mobile App</p> -->

              <!-- Active -->
              <div class="table-responsive">
                <table
                  id="active_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Image</th>
                      <th>Description</th>
                      <th>Qty Total</th>
                      <th>Qty Redeemed</th>
                      <th>Qty Balance</th>
                      <th>Price</th>
                      <th v-if="is_takaful == true">Discount</th>
                      <th v-if="is_takaful == true">Expiry</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in actives" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ data.name }}</td>
                      <td>
                        <div v-for="(img, i) in src" :key="i">
                          <img v-if="img.id == data.id" :src="img.src" style="height: 60px" />
                        </div>
                      </td>
                      <td>{{ data.description }}</td>
                      <td>{{ data.original }}</td>
                      <td>{{ data.redeemed }}</td>
                      <td>{{ data.balance }}</td>
                      <td>{{ data.price }}</td>
                      <td v-if="is_takaful == true">
                        {{ data.discount_type == 1 ? data.voucher_discount + " %" : "$ " + data.voucher_discount }}
                      </td>
                      <td v-if="is_takaful == true">{{ data.duration }} months</td>
                      <td>
                        <router-link
                          :to="redirect(data.id)"
                          class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link>
                        <button
                          class="btn btn-danger btn-rounded btn-block"
                          @click="deactivate(data.id)"
                        >Deactivate</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div id="inactive" class="d-none">
              <!-- Inactive -->
              <h4 class="card-title mb-3">
                <b>Inactive</b>
              </h4>
              <!-- <p>The table shows the list of inactive products and services that approved by the Takaful Brunei</p> -->

              <div class="table-responsive">
                <table
                  id="inactive_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Image</th>
                      <th>Description</th>
                      <th>Qty Total</th>
                      <th>Qty Redeemed</th>
                      <th>Qty Balance</th>
                      <th>Price</th>
                      <th v-if="is_takaful == true">Discount</th>
                      <th v-if="is_takaful == true">Expiry</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in inactives" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ data.name }}</td>
                      <td>
                        <div v-for="(img, i) in src" :key="i">
                          <img v-if="img.id == data.id" :src="img.src" style="height: 60px" />
                        </div>
                      </td>
                      <td>{{ data.description }}</td>
                      <td>{{ data.original }}</td>
                      <td>{{ data.redeemed }}</td>
                      <td>{{ data.balance }}</td>
                      <td>{{ data.price }}</td>
                      <td v-if="is_takaful == true">
                        {{ data.discount_type == 1 ? data.voucher_discount + " %" : "$ " + data.voucher_discount }}
                      </td>
                      <td v-if="is_takaful == true">{{ data.duration }} months</td>
                      <td>
                        <router-link
                          :to="redirect(data.id)"
                          class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link>
                        <button
                          class="btn btn-success btn-rounded btn-block"
                          @click="activate(data.id)"
                        >Activate</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div id="pending" class="d-none">
              <!-- Pending -->
              <h4 class="card-title mb-3">
                <b>Pending</b>
              </h4>
              <!-- <p>The table shows the list of current pending request of products and services to be checked by Takaful Brunei</p> -->

              <div class="table-responsive">
                <table
                  id="pending_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Image</th>
                      <th>Description</th>
                      <th>Remarks</th>
                      <th>Quantity</th>
                      <th>Price</th>
                      <th v-if="is_takaful == true">Discount</th>
                      <th v-if="is_takaful == true">Expiry</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in pendings" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ data.name }}</td>
                      <td>
                        <div v-for="(img, i) in src" :key="i">
                          <img v-if="img.id == data.id" :src="img.src" style="height: 60px" />
                        </div>
                      </td>
                      <td>{{ data.description }}</td>
                      <td>{{ data.remarks }}</td>
                      <td>{{ data.quantity }}</td>
                      <td>{{ data.price }}</td>
                      <td v-if="is_takaful == true">
                        {{ data.discount_type == 1 ? data.voucher_discount + " %" : "$ " + data.voucher_discount }}
                      </td>
                      <td v-if="is_takaful == true">{{ data.duration }} months</td>
                      <td>
                        <router-link
                          :to="redirect(data.id)"
                          class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div id="resubmit" class="d-none">
              <!-- Resubmit -->
              <h4 class="card-title mb-3">
                <b>Resubmit</b>
              </h4>
              <!-- <p>The table shows the list of products and services that requires amendment via request remark from the Takaful Brunei</p> -->

              <div class="table-responsive">
                <table
                  id="resubmit_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Image</th>
                      <th>Description</th>
                      <th>Remarks</th>
                      <th>Quantity</th>
                      <th>Price</th>
                      <th v-if="is_takaful == true">Discount</th>
                      <th v-if="is_takaful == true">Expiry</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in remarks" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ data.name }}</td>
                      <td>
                        <div v-for="(img, i) in src" :key="i">
                          <img v-if="img.id == data.id" :src="img.src" style="height: 60px" />
                        </div>
                      </td>
                      <td>{{ data.description }}</td>
                      <td>{{ data.remarks }}</td>
                      <td>{{ data.quantity }}</td>
                      <td>{{ data.price }}</td>
                        <td v-if="is_takaful == true">
                          {{ data.discount_type == 1 ? data.voucher_discount + " %" : "$ " + data.voucher_discount }}
                        </td>
                        <td v-if="is_takaful == true">{{ data.duration }} months</td>
                      <td>
                        <router-link
                          :to="redirect(data.id)"
                          class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


    <script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "vendor-products",
  components: {},

  data() {
    return {
      pendings: [],
      remarks: [],
      approved: [],
      actives: [],
      inactives: [],
      src: [],
      quantitites: [],
      is_takaful: false,
    };
  },

  methods: {
    checkProfile() {
      let token = localStorage.getItem("token");
      let user = JSON.parse(localStorage.getItem("user"));

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/vendor/" + user.id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            let vendor_data = res.data.vendor[0];
            this.takaful_products = res.data.products;

            if(vendor_data.qr_string == "qrstringtakafulbrunei"){
                this.is_takaful = true
            }

          })
          .then((ok) =>{
              this.loadData()
          })
      }
    },

    loadProducts() {
      let token = localStorage.getItem("token");
      let user = JSON.parse(localStorage.getItem("user"));

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/vendor/products", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.pendings = res.data.products.pendings;
            this.remarks = res.data.products.remarks;
            this.approved = res.data.products.approved;
            this.quantitites = res.data.quantity;

            if (this.approved != null) {
              this.approved.forEach(approved => {
                this.quantitites.forEach(quantity => {
                  if (quantity.product_id == approved.id) {
                    approved.original = quantity.original;
                    approved.redeemed = quantity.redeemed;
                    approved.balance = quantity.balance;
                  }
                });

                if (approved.active == 1) {
                  this.actives.push(approved);
                } else if (approved.active == 0) {
                  this.inactives.push(approved);
                }
              });
            }

            // Load Images
            if (this.pendings != null) {
              this.loadPendingImage(token);
            }

            if (this.remarks != null) {
              this.loadRemarksImage(token);
            }

            if (this.approved != null) {
              this.loadApprovedImage(token);
            }
          })
          .then(function() {
            $("#active_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });

            $("#inactive_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });

            $("#pending_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });

            $("#resubmit_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });
          });
      }
    },

    loadPendingImage(token) {
      this.pendings.forEach(data => {
        axios
          .get(axios.lpsURL + "/vendor_product/show/" + data.id, {
            headers: {
              Authorization: "Bearer " + token
            },
            responseType: "blob"
          })
          .then(response => {
            let reader = new FileReader();
            reader.readAsDataURL(response.data);
            reader.onload = () => {
              // this.src = reader.result

              let src = {
                id: data.id,
                src: reader.result
              };
              this.src.push(src);
            };
          });
      });
    },

    loadRemarksImage(token) {
      this.remarks.forEach(data => {
        axios
          .get(axios.lpsURL + "/vendor_product/show/" + data.id, {
            headers: {
              Authorization: "Bearer " + token
            },
            responseType: "blob"
          })
          .then(response => {
            let reader = new FileReader();
            reader.readAsDataURL(response.data);
            reader.onload = () => {
              // this.src = reader.result

              let src = {
                id: data.id,
                src: reader.result
              };
              this.src.push(src);
            };
          });
      });
    },

    loadApprovedImage(token) {
      this.approved.forEach(data => {
        axios
          .get(axios.lpsURL + "/vendor_product/show/" + data.id, {
            headers: {
              Authorization: "Bearer " + token
            },
            responseType: "blob"
          })
          .then(response => {
            let reader = new FileReader();
            reader.readAsDataURL(response.data);
            reader.onload = () => {
              // this.src = reader.result

              let src = {
                id: data.id,
                src: reader.result
              };
              this.src.push(src);
            };
          });
      });
    },

    deactivate(id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
      }

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }

        axios
          .post(
            axios.lpsURL + "/vendor_product/deactivate/" + id,
            {},
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )

          .then(res => {
            if (res.data.success) {
              swal({
                title: "Success",
                icon: "success",
                text: res.data.message
              }).then(() => {
                this.loadData();
              });
            } else {
              swal({
                title: "Failed",
                icon: "error",
                text: res.data.message
              });
            }
          });
      });
    },

    activate(id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
      }

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }

        axios
          .post(
            axios.lpsURL + "/vendor_product/activate/" + id,
            {},
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            if (res.data.success) {
              swal({
                title: "Success",
                icon: "success",
                text: res.data.message
              }).then(() => {
                this.loadData();
              });
            } else {
              swal({
                title: "Failed",
                icon: "error",
                text: res.data.message
              });
            }
          });
      });
    },

    loadData() {
      this.destroyDatatable();
      this.loadProducts();
    },

    active() {
      $("#active").removeClass("d-none");
      $("#inactive").addClass("d-none");
      $("#pending").addClass("d-none");
      $("#resubmit").addClass("d-none");

      $("#btn-active").addClass("active");
      $("#btn-inactive").removeClass("active");
      $("#btn-pending").removeClass("active");
      $("#btn-resubmit").removeClass("active");
    },

    inactive() {
      $("#inactive").removeClass("d-none");
      $("#pending").addClass("d-none");
      $("#active").addClass("d-none");
      $("#resubmit").addClass("d-none");

      $("#btn-inactive").addClass("active");
      $("#btn-active").removeClass("active");
      $("#btn-pending").removeClass("active");
      $("#btn-resubmit").removeClass("active");
    },

    pending() {
      $("#pending").removeClass("d-none");
      $("#inactive").addClass("d-none");
      $("#active").addClass("d-none");
      $("#resubmit").addClass("d-none");

      $("#btn-pending").addClass("active");
      $("#btn-inactive").removeClass("active");
      $("#btn-active").removeClass("active");
      $("#btn-resubmit").removeClass("active");
    },

    resubmit() {
      $("#resubmit").removeClass("d-none");
      $("#inactive").addClass("d-none");
      $("#active").addClass("d-none");
      $("#pending").addClass("d-none");

      $("#btn-resubmit").addClass("active");
      $("#btn-inactive").removeClass("active");
      $("#btn-pending").removeClass("active");
      $("#btn-active").removeClass("active");
    },

    destroyDatatable() {
      this.src = [];
      $("#active_tbl").DataTable().clear().destroy();
      $("#inactive_tbl").DataTable().clear().destroy();
      $("#pending_tbl").DataTable().clear().destroy();
      $("#resubmit_tbl").DataTable().clear().destroy();
    },

    redirect(id) {
      return "/products-services/update/" + id;
    }
  },

  mounted() {
    this.checkProfile();
    // this.loadData();
  }
};
</script>
